import { extractTemplateVariables } from "@/lib/utils/crm/template-variables";
import type { VariableState, VariableAction } from "../types/variable-types";

// ============================================================================
// VARIABLE REDUCER
// ============================================================================

export function variableReducer(state: VariableState, action: VariableAction): VariableState {
  switch (action.type) {
    case "SET_VALUE":
      return {
        ...state,
        values: {
          ...state.values,
          [action.varName]: action.value,
        },
      };

    case "SET_VALUES":
      return {
        ...state,
        values: action.values,
      };

    case "START_EDITING":
      return {
        ...state,
        editingField: action.varName,
        draftValue: action.currentValue,
      };

    case "UPDATE_DRAFT":
      return {
        ...state,
        draftValue: action.value,
      };

    case "APPLY_DRAFT":
      return {
        ...state,
        values: {
          ...state.values,
          [action.varName]: state.draftValue,
        },
        editingField: null,
        draftValue: "",
      };

    case "CANCEL_EDITING":
      return {
        ...state,
        editingField: null,
        draftValue: "",
      };

    case "RESET":
      return {
        values: {},
        editingField: null,
        draftValue: "",
        allVariables: [],
        autoFilledVariables: {},
      };

    case "SET_ALL_VARIABLES":
      return {
        ...state,
        allVariables: action.variables,
      };

    case "SET_AUTO_FILLED":
      return {
        ...state,
        autoFilledVariables: action.variables,
      };

    case "UPDATE_TEMPLATE_VARIABLES": {
      const allVars = extractTemplateVariables(action.subject + " " + action.body);
      console.log("[VariableContext] UPDATE_TEMPLATE_VARIABLES reducer:", {
        subject: action.subject.substring(0, 100) + (action.subject.length > 100 ? "..." : ""),
        body: action.body.substring(0, 100) + (action.body.length > 100 ? "..." : ""),
        extractedVariables: allVars,
      });
      return {
        ...state,
        allVariables: allVars,
      };
    }

    default:
      return state;
  }
}
